"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _index = _interopRequireDefault(require("@/directive/clipboard/index.js"));
var _common = require("@/api/common");
var _default = exports.default = {
  directives: {
    clipboard: _index.default
  },
  data: function data() {
    return {
      googleAuth: false,
      googleImg: '',
      form: {
        googleKey: '',
        googleCode: '',
        loginPwd: '',
        account: ''
      },
      formRules: {
        googleCode: {
          required: true,
          trigger: 'blur',
          message: this.$t('form.pleaseEnter') + this.$t('form.googleCode')
        },
        loginPwd: {
          required: true,
          trigger: 'blur',
          message: this.$t('form.pleaseEnter') + this.$t('form.loginPwd')
        }
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['isBindGoogleAuth'])),
  watch: {
    isBindGoogleAuth: function isBindGoogleAuth(val) {
      if (!this.isBindGoogleAuth && process.env.VUE_APP_ENV === 'prod') {
        this.googleAuth = true;
      }
    }
  },
  mounted: function mounted() {
    if (!this.isBindGoogleAuth && process.env.VUE_APP_ENV === 'prod') {
      this.load();
      this.googleAuth = true;
    } else {
      this.googleAuth = false;
    }
  },
  methods: {
    load: function () {
      var _load = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$toopenGoogleAu, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _common.toopenGoogleAuthenticator)();
            case 1:
              _yield$toopenGoogleAu = _context.v;
              code = _yield$toopenGoogleAu.code;
              data = _yield$toopenGoogleAu.data;
              if (code === 0) {
                this.form.googleKey = data.googleKey;
                this.googleImg = data.googleImg;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }(),
    confirm: function confirm() {
      var _this = this;
      var url = window.location.host;
      if (url === process.env.VUE_APP_URL_ADMIN_HOST) {
        this.form.account = 'admin';
      } else if (url === process.env.VUE_APP_URL_CHANNEL_HOST) {
        this.form.account = 'channel';
      }
      this.$refs['form'].validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(valid) {
          var _yield$googleVerify, code;
          return (0, _regenerator2.default)().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                if (valid) false;
                _context3.n = 1;
                return (0, _common.googleVerify)(_this.form);
              case 1:
                _yield$googleVerify = _context3.v;
                code = _yield$googleVerify.code;
                if (code === 0) {
                  _this.$message({
                    message: _this.$t('form.submitSuccess'),
                    type: 'success'
                  });
                  setTimeout(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
                    return (0, _regenerator2.default)().w(function (_context2) {
                      while (1) switch (_context2.n) {
                        case 0:
                          _this.googleAuth = false;
                          _context2.n = 1;
                          return _this.$store.dispatch('user/logout');
                        case 1:
                          _this.$router.push("/login?redirect=".concat(_this.$route.fullPath));
                        case 2:
                          return _context2.a(2);
                      }
                    }, _callee2);
                  })), 1500);
                }
              case 2:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    clipboardSuccess: function clipboardSuccess() {
      this.$message({
        message: 'Copy successfully',
        type: 'success',
        duration: 1500
      });
    }
  }
};